import moment from 'moment';
import { select } from '../shared/utils/dom';
import { formatBasicCurrency } from '../shared/utils/misc';
import { delimiters } from '../shared/constants';
import loadingMixin from '../shared/vue/mixins/loading';

window.moment = moment;

export default function () {
  const el = select('[data-vue-app="meter-usage-comparison"]');
  if (!el) {
    return;
  }

  const rowData = function (date, avgTemp, units, bill) {
    return {
      'ReadDate': date, // eslint-disable-line quote-props
      'MonthName': moment(date).format("MMMM"), // eslint-disable-line quote-props
      'MonthAbbrev': moment(date).format("MMMM"), // eslint-disable-line quote-props
      'Year': moment(date).format("YYYY"), // eslint-disable-line quote-props
      'ReadMethod': 'Actual', // eslint-disable-line quote-props
      'AverageTemp': avgTemp, // eslint-disable-line quote-props
      'NumberOfBillingDays': Math.floor(Math.random() * (31 - 29)) + 29, // eslint-disable-line quote-props
      'UnitsUsed': units, // eslint-disable-line quote-props
      'BillAmount': bill, // eslint-disable-line quote-props
      'State': 'estimated', // eslint-disable-line quote-props
      'Reading': 8860.0, // eslint-disable-line quote-props
      'AverageUsage': 91.41666666666667, // eslint-disable-line quote-props
      'AverageEnergyPercentageChange': 138, // eslint-disable-line quote-props
      'ShowTip': false, // eslint-disable-line quote-props
    };
  };
  new Vue({ // eslint-disable-line no-new
    el,
    delimiters,
    mixins: [loadingMixin],
    data: {
      tableData: window.VueTables.usageBarData || [
        rowData('2017-02-21T00:00:00Z', 0.3, 87.5, 32.5),
        rowData('2017-01-23T00:00:00Z', 0.5, 100, 70),
        rowData('2016-12-20T00:00:00Z', 5, 50, 78.9),
        rowData('2016-11-17T00:00:00Z', 11, 87.5, 53.4),
        rowData('2016-10-19T00:00:00Z', 20, 90.7, 105.6),
        rowData('2016-09-20T00:00:00Z', 0.3, 40.2, 56.4),
        rowData('2016-08-19T00:00:00Z', -10, 200.1, 550.5),
        rowData('2016-07-21T00:00:00Z', 2, 65.8, 120.2),
        rowData('2016-06-21T00:00:00Z', 3, 45.2, 75.6),
        rowData('2016-05-20T00:00:00Z', 5, 59.2, 95.7),
        rowData('2016-04-21T00:00:00Z', 1, 40.1, 62.5),
        rowData('2016-03-22T00:00:00Z', 0.2, 100.2, 150.6),
        rowData('2016-02-22T00:00:00Z', 0.9, 129.7, 170.1),
        rowData('2016-01-22T00:00:00Z', 1.2, 160.5, 250.4),
        rowData('2015-12-22T00:00:00Z', 1.5, 170.3, 280.8),
      ],
      dates1: [],
      dates2: [],
      selectedMonth1: '',
      selectedMonth2: '',
      avgTemperature1: '',
      avgTemperature2: '',
      unitsUsed1: '',
      unitsUsed2: '',
      billAmount1: '',
      billAmount2: '',
      temperatureVerbiage: 'colder',
      percentageChangeVerbiage: 'higher',
      percentageArrow: 'usage-percentage-up',
    },
    methods: {
      formatDate(date) {
        return moment(date).format("MMMM YYYY");
      },
    },
    mounted() {
      if (this.tableData.length > 0) {
        this.dates1 = this.tableData.map((t, index) => {
          const mDate = moment(t.ReadDate);
          const valueSuffix = (index === 0 ? "(This bill)" : "");

          return { key: mDate, value: `${mDate.format("MMMM YYYY")} ${valueSuffix}` };
        });
        const startIndex = (this.dates1.length > 0 ? 1 : 0);
        const endIndex = (this.dates1.length > 12 ? 13 : this.dates1.length);
        this.dates2 = JSON.parse(JSON.stringify(this.dates1));
        this.dates2 = this.dates2.slice(startIndex, endIndex);

        if (this.dates1.length > 11) {
          this.dates1 = this.dates1.slice(0, 12);
        }

        if (this.dates2.length > 1) {
          this.dates2[0].value = `${this.dates2[0].value} (Last month)`;
        }

        const lastYear = moment(this.dates1[0].key).add('years', -1);
        const lastYearDate = this.dates2.find(d => moment(d.key).format("MM YYYY") === lastYear.format("MM YYYY"));

        if (lastYearDate) {
          lastYearDate.value = `${lastYearDate.value} (Last year)`;
          this.selectedMonth2 = lastYearDate.key;
        } else {
          this.selectedMonth2 = this.dates2[0].key;
        }

        this.selectedMonth1 = this.dates1[0].key;
      }
    },
    watch: {
      selectedMonth1() {
        const meterData = this.tableData.filter(d => moment(d.ReadDate).format("MM DD YYYY") === moment(this.selectedMonth1).format("MM DD YYYY"));

        if (meterData) {
          this.unitsUsed1 = meterData[0].UnitsUsed;
          this.billAmount1 = formatBasicCurrency(meterData[0].BillAmount);
          this.avgTemperature1 = meterData[0].AverageTemp;
        }
      },
      selectedMonth2() {
        const meterData = this.tableData.filter(d => moment(d.ReadDate).format("MM DD YYYY") === moment(this.selectedMonth2).format("MM DD YYYY"));

        if (meterData) {
          this.unitsUsed2 = meterData[0].UnitsUsed;
          this.billAmount2 = formatBasicCurrency(meterData[0].BillAmount);
          this.avgTemperature2 = meterData[0].AverageTemp;
        }
      },
    },
    computed: {
      percentageUnitChange() {
        const percentageDiff = Math.round((parseFloat(((this.unitsUsed1 - this.unitsUsed2) / (this.unitsUsed2 === 0 ? 1 : this.unitsUsed2)), 10) * 100), 0);
        this.percentageChangeVerbiage = (percentageDiff >= 0 ? "higher" : "lower");
        this.percentageArrow = (percentageDiff >= 0 ? "usage-percentage-up" : "usage-percentage-down");

        return Math.abs(percentageDiff);
      },
      temperatureChange() {
        const tempDiff = (this.avgTemperature1 - this.avgTemperature2).toFixed(1);
        this.temperatureVerbiage = (tempDiff >= 0 ? "warmer" : "colder");

        return Math.abs(tempDiff);
      },
      billingDaysVerbiage() {
        const billingDaysDiff = (moment(this.selectedMonth1).daysInMonth() - moment(this.selectedMonth2).daysInMonth());
        const pluarlize = (Math.abs(billingDaysDiff) === 0 || Math.abs(billingDaysDiff) > 1);
        const billingDaysText = `There ${pluarlize ? "were" : "was"} ${Math.abs(billingDaysDiff)} ${billingDaysDiff >= 0 ? "more" : "less"} billing ${pluarlize ? "days" : "day"} in ${moment(this.selectedMonth1).format("MMMM")}`;

        return billingDaysText;
      },
      blueBarWidth() {
        const barWidth = this.unitsUsed1 >= this.unitsUsed2 ? 100 : Math.round(100 - (parseFloat(((this.unitsUsed2 - this.unitsUsed1) / (this.unitsUsed2 === 0 ? 1 : this.unitsUsed2)), 10) * 100), 0);

        return `${barWidth}%`;
      },
      grayBarWidth() {
        const barWidth = this.unitsUsed2 >= this.unitsUsed1 ? 100 : Math.round(100 - (parseFloat(((this.unitsUsed1 - this.unitsUsed2) / (this.unitsUsed1 === 0 ? 1 : this.unitsUsed1)), 10) * 100), 0);

        return `${barWidth}%`;
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/usageComparison.js